/**
 * Provides a hook for detecting if the device is mobile.
 * 
 * @packageDocumentation
 * @module useIsMobile
 * @public
 */

// TODO: reevaluate when window.innerWidth changes

/**
 * Assess whether the device is mobile based on a combination of:
 * - `navigator.useAgentData.mobile`
 * - `navigator.userAgent` parsed for mobile OS names
 * - touch capability detection
 * - small screen size detection
 */
export function useIsMobile() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userAgentDataMobile: boolean = (navigator as any).userAgentData?.mobile;
  const userAgent = navigator.userAgent;
  const hasMobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      userAgent
    );
  const isTouchDevice =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth < 768;

  return (
    userAgentDataMobile ||
    hasMobileUserAgent ||
    (isTouchDevice && isSmallScreen)
  );
}
